import "date-fns";
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "components/Table/Table";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import ListItem from "@material-ui/core/ListItem";
import Button from "components/CustomButtons/Button.js";
import Chart from "components/Chart/Chart.js";
import Grid from '@material-ui/core/Grid';
import { getAllLockers } from "../../services/lockers/lockers";
import { getOrdersFilteredByMonthYear } from "../../services/orders/orders";
import { getSlots } from "../../services/slots/slots";
import { getAllLockersSelect } from "../../services/lockers/lockers";
import { getUser } from "../../services/users/users";
import CircularProgress from "../Circular/Circular";
import Tooltip from '@material-ui/core/Tooltip';
import ExportCsv from "exportCsv.js";
import MomentUtils from "@date-io/date-fns";
import pt from "date-fns/locale/pt";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';

import './style.css';

const useStyles = (theme) => ({
    iconView: {
        color: "gray !important",
    },
    root: {
        "& .MuiFormControl-root": {
            margin: theme.spacing(1),
            width: 200,
        },
    },
    dialog: {
        "& .MuiPaper-root": {
            margin: theme.spacing(1),
            width: 250,
            height: 200,
        },
    },
    green: {
        "& label.Mui-focused": {
            color: "green",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "green",
        },
    },
    red: {
        "& label.Mui-focused": {
            color: "red",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "red",
        },
    },
    semDados: {
        color: '#333333'
    }
});

class OccupancyRateGroup extends Component {
    constructor(props) {
        super(props);
        this.getOrders = this.getOrders.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.getMinMax = this.getMinMax.bind(this);
        this.handleDateChangeInit = this.handleDateChangeInit.bind(this);
        this.handleDateChangeFinal = this.handleDateChangeFinal.bind(this);
        this.handleChangeLocker = this.handleChangeLocker.bind(this);
        this.handleChangeGroup = this.handleChangeGroup.bind(this);

        this.state = {
            selectedDate: null,
            sizes: [
                {
                    value: "small",
                    label: "Pequeno",
                },
                {
                    value: "medium",
                    label: "Médio",
                },
                {
                    value: "large",
                    label: "Grande",
                },
                {
                    value: null,
                    label: "Todos",
                }
            ],
            size: null,
            data: [],
            circular: true,
            chartData: [],
            dataExport: [],
            dataLockers: this.props.dataLockers,
            selected: this.props.selected ? this.props.selected : 'Todos',
            selectedDateInital: new Date().setDate(new Date().getDate() - 15),
            selectedDateFinal: new Date(),
            groups: [],
            lockers: [],
            group: null,
            lockerS: null,
            groupedLockers: {}
        };
    }

    componentDidMount() {
        this.getOrders();
    }

    handleDateChange(selectedDate) {
        this.setState({ selectedDate });
    }

    handleDateChangeInit(selectedDateInital) {
        this.setState({ selectedDateInital });
    }

    handleDateChangeFinal(selectedDateFinal) {
        this.setState({ selectedDateFinal });
    }

    handleChange = (size) => {
        this.setState({ size: size.target.value });
    };

    handleChangeLocker(locker) {
        this.setState({ lockerS: locker.target.value });
    };

    handleChangeGroup(group) {
        this.setState({ group: group.target.value });
    }

    handleExport = () => {
        const { dataExport } = this.state;
        ExportCsv(dataExport);
    };

    handleSearch = () => {
        let selectedDate = (this.state.selectedDate) ? new Date(this.state.selectedDate) : new Date();
        this.setState({ circular: true });
        this.getOrders();
    };

    getOrders = () => {
        const { selectedDateFinal, selectedDateInital, group, lockerS } = this.state;

        let data = [];
        let chartData = [];
        let dataExport = [];
        let year = new Date(selectedDateInital).getFullYear();
        let month = new Date(selectedDateInital).getMonth() + 1;
        let day = new Date(selectedDateInital).getDate();
        let groupedLockers = {};

        //let currentUser = JSON.parse(localStorage.getItem("user"));

        //getUser(currentUser.data.id, (us) => {
        getAllLockersSelect((us) => {

            us.listGrupos.push({
                value: null,
                label: "Todos",
            });

            us.listLockers.push({
                value: null,
                label: "Todos",
            });

            us.listGrupos.forEach(g => {
                groupedLockers[g.label] = [];
            });

            this.setState({ groups: us.listGrupos, lockers: us.listLockers });

            getAllLockers((lockers) => {

                if (lockers.length === 0) {
                    this.setState({ circular: false, data });
                }

                lockers.forEach((locker, index) => {
                    let { id, group_lockers, name } = locker;

                    if (groupedLockers[group_lockers]) {
                        groupedLockers[group_lockers].push(`- ${name} \n\n`);
                    }

                    let availableLockers = null;
                    let availableGroups = null;

                    if (group || lockerS) {
                        availableLockers = lockerS === id;
                        availableGroups = group === group_lockers;
                    } else {
                        availableLockers = us.listLockers.findIndex(l => l.value == id);
                        availableGroups = us.listGrupos.findIndex(g => g.value == group_lockers);
                    }

                    if (availableLockers || availableGroups) {
                        getSlots(id, (slots) => {
                            let capacity = (slots.length) ? slots.length - 1 : 0;

                            getOrdersFilteredByMonthYear(id, year, month, async (order) => {
                                if (this.state.size)
                                    order = order.filter(o => o.size === this.state.size);

                                while (month) {
                                    let monthDays = new Date(year, month, 0).getDate();

                                    if (month == (new Date(selectedDateFinal).getMonth() + 1) && year == (new Date(selectedDateFinal).getFullYear())) {
                                        monthDays = new Date(selectedDateFinal).getDate();
                                    }
                                    for (var i = day; i <= monthDays; i++) {

                                        let minMax = await this.getMinMax(order, `${month}/${i}/${year}`, selectedDateFinal, capacity);

                                        let ind = data.findIndex(d => d[0] === `${i}/${month}/${year}`);

                                        if (ind >= 0) {

                                            if (`${minMax.max}%` > data[ind][1]) {
                                                data[ind][1] = `${minMax.max}%`;
                                                chartData[ind]['max'] = minMax.max;
                                                dataExport[ind]['Taxa de ocupação'] = `${minMax.max}%`;
                                            }
                                        } else {
                                            data.push([`${i}/${month}/${year}`, `${minMax.max}%`]);
                                            dataExport.push({ Dia: `${i}/${month}/${year}`, 'Taxa de ocupação': `${minMax.max}%` })
                                            chartData.push({ year: `${i}/${month}`, max: minMax.max });
                                        }
                                    }

                                    if (month == (new Date(selectedDateFinal).getMonth() + 1) && year == (new Date(selectedDateFinal).getFullYear())) {
                                        break;
                                    }

                                    if (month == 12) {
                                        year++;
                                        month = 1;
                                    } else {
                                        month++;
                                    }

                                    day = 1;

                                }
                            });
                        });
                    }

                    setTimeout(() => {
                        if (index === lockers.length - 1) {
                            this.setState({ circular: false, data, chartData, dataExport, groupedLockers });
                        }
                    }, 1000)

                });
            });
        });
    }

    getMinMax = async (order, date, selectedDateFinal, capacity) => {

        let finalDate = (new Date(selectedDateFinal).setHours(23, 59, 0, 0) > new Date().setHours(23, 59, 0, 0)) ? new Date() : new Date(selectedDateFinal);

        let filteredOrdersLater = order.filter(o => (o.collectedAt) ? new Date(o.collectedAt).getTime() > new Date(date).setHours(23, 59, 0, 0) : true);
        filteredOrdersLater = filteredOrdersLater.filter(o => new Date(o.allocatedAt).getTime() <= new Date(date).setHours(23, 59, 0, 0) && new Date(date).setHours(23, 59, 0, 0) <= finalDate.setHours(23, 59, 0, 0));

        filteredOrdersLater = Number(((filteredOrdersLater.length / capacity) * 100).toFixed(2));
        filteredOrdersLater = filteredOrdersLater ? filteredOrdersLater : 0;

        return ({
            max: filteredOrdersLater
        });
    }

    render() {
        const { classes } = this.props;
        const { selectedDateInital, selectedDateFinal, sizes, size, data, circular, chartData, groups, lockers, group, lockerS, groupedLockers } = this.state;

        let layout = (circular) ?
            <div className={classes.root}>
                <CircularProgress />
            </div> :
            this.state.data.length === 0 ?
                <div>
                    <span className={classes.semDados}>Sem dados disponíveis</span>
                </div> :
                <div>
                    <h5>TAXA DE OCUPAÇÃO</h5>
                    <div className="occupancy-top-group">
                        <MuiPickersUtilsProvider utils={MomentUtils} locale={pt}>
                            <Grid container justify="space-around">
                                <KeyboardDatePicker
                                    locale="pt"
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    label="Data Inicial"
                                    value={selectedDateInital}
                                    onChange={this.handleDateChangeInit}
                                />
                            </Grid>
                        </MuiPickersUtilsProvider>
                        <MuiPickersUtilsProvider utils={MomentUtils} locale={pt}>
                            <Grid container justify="space-around">
                                <KeyboardDatePicker
                                    locale="pt"
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    label="Data Final"
                                    value={selectedDateFinal}
                                    onChange={this.handleDateChangeFinal}
                                />
                            </Grid>
                        </MuiPickersUtilsProvider>
                        <TextField
                            className={classes.green}
                            id="outlined-size-input"
                            select
                            label="Tamanho"
                            value={size}
                            onChange={this.handleChange}
                        >
                            {sizes.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        <Button onClick={this.handleSearch} color="primary">
                            Pesquisar
                        </Button>
                        <Button onClick={this.handleExport} color="default">
                            Exportar
                        </Button>
                        <TextField
                            className={classes.green}
                            id="outlined-size-input"
                            select
                            label="Locker"
                            value={lockerS}
                            onChange={this.handleChangeLocker}
                        >
                            {lockers.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            className={classes.green}
                            id="outlined-size-input"
                            select
                            label="Grupo"
                            value={group}
                            onChange={this.handleChangeGroup}
                        >
                            {groups.map((option) => (
                                <Tooltip title={groupedLockers[option.value]} key={option.value} value={option.value}>
                                    <MenuItem className='item-group' key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                </Tooltip>
                            ))}
                        </TextField>
                    </div>
                    <div className="occupancy-down">
                        <Table
                            tableHeaderColor="primary"
                            tableHead={["Dia", "Taxa de ocupação"]}
                            tableData={data}
                        />
                        <div className="char-area">
                            <Chart info={chartData} />
                        </div>
                    </div>
                </div>;

        return (
            <div>
                {layout}
            </div>
        );
    }
}
export default withStyles(useStyles)(OccupancyRateGroup);
